export default {
  inserted (el, binding, vnode) {
    const input = el.querySelector('input');
    const patter = /[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g;
    input.addEventListener('input', function (e) {
      let val = e.target.value.replace(binding.value || patter, '');
      input.value = val;
      vnode.data.model.callback(val);
    });
  }
};
